import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ContactForm from '../../components/contact/contactform.components'
import { useOrder } from '../../hooks/useAuth'
import './about.styles.scss'

const DEFAULT_ABOUT = {
  about_img_url:
    'https://img.freepik.com/premium-photo/portrait-smiling-female-baker-leaning-stack-bread_604472-24133.jpg',
  about_name: 'Sandy',
  about_title: 'Baker & founder',
  about_text:
    "From decadent cakes to mouthwatering pastries, every creation is crafted with passion and care. Whether for a celebration or a quiet craving, we bake with the finest ingredients and a lot of love.",
  company: {},
}

const AboutPage = () => {
  const { curPage } = useOrder()
  const [page, setPage] = useState({ ...DEFAULT_ABOUT, ...curPage })

  useEffect(() => {
    if (curPage) {
      setPage({ ...DEFAULT_ABOUT, ...curPage })
    }
  }, [curPage])

  const {
    about_img_url,
    about_name,
    about_title,
    about_text,
    company,
  } = page

  return (
    <>
      <section className="about-v2">
        <div className="about-v2__glow about-v2__glow--a" aria-hidden="true" />
        <div className="about-v2__glow about-v2__glow--b" aria-hidden="true" />

        <div className="about-v2__inner">
          <div className="about-v2__intro">
            <p className="about-v2__eyebrow">Our story</p>
            <h1>
              <span className="about-v2__script">About</span>
              <span className="about-v2__solid">Cake by Sandy</span>
            </h1>
            <p className="about-v2__lead">A little about the kitchen behind the cakes.</p>
          </div>

          <div className="about-v2__grid">
            <figure className="about-v2__media">
              <div className="about-v2__photo">
                <img
                  src={about_img_url || DEFAULT_ABOUT.about_img_url}
                  alt={about_name || 'Baker portrait'}
                />
              </div>
              <figcaption>
                <strong>{about_name || DEFAULT_ABOUT.about_name}</strong>
                <span>{about_title || DEFAULT_ABOUT.about_title}</span>
              </figcaption>
            </figure>

            <div className="about-v2__copy">
              <p>{about_text || DEFAULT_ABOUT.about_text}</p>
              <div className="about-v2__actions">
                <Link to="/book" className="about-v2__cta">
                  Order now
                </Link>
                <Link to="/gallery" className="about-v2__ghost">
                  See gallery
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactForm company={company || {}} />
    </>
  )
}

export default AboutPage
